import React, { useState, useEffect } from 'react';
import styles from './index.module.scss'
import './index.scss'
import { ApiCore } from '../../api/index';
import { Picker, ProgressCircle } from 'antd-mobile-v5';
import dayjs from 'dayjs';
import chart_rate_detail from '../../static/images_ae/alkTest/chart_rate_detail.png';
import chart_arrow_down_white from '../../static/images_ae/alkTest/chart_arrow_down_white.png';
import chart_record from '../../static/images_ae/alkTest/chart_record.png';
import chart_arrow_down from '../../static/images_ae/alkTest/chart_arrow_down.png';
import chart_health_trend from '../../static/images_ae/alkTest/chart_health_trend.png';
import chart_degree_heavy from '../../static/images_ae/alkTest/chart_degree_heavy.png';
import chart_degree_middle from '../../static/images_ae/alkTest/chart_degree_middle.png';
import chart_degree_light from '../../static/images_ae/alkTest/chart_degree_light.png';
import arrow_down_gray from '../../static/images_ae/alkTest/arrow_down_gray.png';
import chart_degree_none from '../../static/images_ae/alkTest/chart_degree_none.png';
import icon_health_title from '../../static/images_ae/alkTest/icon_health_title.png';
import to_expand_arrow from '../../static/images_ae/alkTest/to_expand_arrow.png';
import commonQA from '../../static/images_ae/alkTest/commonQA.png';
import QA from '../../static/images_ae/alkTest/QA.png';
import r_arrow_blue from '../../static/images_ae/alkTest/r_arrow_blue.png';
import utils from '../../utils/utils';
import * as echarts from 'echarts';
import { withRouter } from 'react-router-dom';

const api = new ApiCore();

// const rateColor = {
//     10: '#3C94F7',
//     20: '#3C94F7',
// };

const rateColor = [
    '#3C94F7', '#4185ED', '#447AE6', '#4870E1', '#4C66DA',
    '#4F5BD4', '#5250CD', '#5746C7', '#5A3CC1', '#5F2DB7'
]

const rateTitleColor = [
    '#4188EF', '#E3B721', '#00BE24', '#213FE3', '#EF41CE',
    '#E55B32', '#ADED00', '#ADED00', '#20E7EF', '#EDE400',
    '#87AEDB', '#CC3B3B'
]

const AeTestDetail = (props: any) => {

    const [currenrYear, setCurrenrYear] = useState<any>([(new Date().getFullYear())])
    const [yearColumns, setYearColumns] = useState<any>([])
    const [recordData, setRecordData] = useState<any>({})
    const [recordTime, setRecordTime] = useState<any>('')
    const [score, setScore] = useState<any>('')
    const [questionnaireCode, setQuestionnaireCode] = useState<any>('')
    const [ruleType, setRuleType] = useState<any>('')
    const [visible, setVisible] = useState(false)
    const [isTextExpand, setIsTextExpand] = useState(false)
    const [floorModules, setFloorModules] = useState<any>([]);
    const [FAQList, setFAQList] = useState<any>([]);
    const [tabNameActiveIndex, setTabNameActiveIndex] = useState<any>(0);

    useEffect(() => {
        window.document.title = '自测记录';
        initDate();
        prepareData();
    }, [])

    const initDate = () => {
        initYearColumns();
    }

    const initYearColumns = () => {
        const _arr = [];
        const _thisYear = (new Date().getFullYear());
        for (let index = _thisYear; index > 1990; index--) {
            _arr.push({
                label: index + '', value: index + ''
            });
        } 
        setYearColumns([_arr]);
    }

    const prepareData = async () => {
        const urlParams = utils.getUrlParams() || {};
        let id = urlParams.id;
        api.getQuestionnaireRecordDetail({
            recordId: id
        }).then(async (res: any) => {
            if (res.code == 0) {
                const _data = res.data || {};
                setRecordData(_data)
                let _time = _data.createTime ? _data.createTime.slice(0, 10) : '';
                setRecordTime(_time);
                const urlParams = utils.getUrlParams();
                let _score = _data.score;
                if (urlParams.testScore) {
                    _score = urlParams.testScore;
                }
                const sourceData = _data.data ? JSON.parse(_data.data): {};
                const { data: healthData = {} } : any = await api.getHealthDisplayGet({ displayCode: _data.displayCode, version: _data.displayVersion });
                let mModule = [];
                let hasHealthTreand = false;
                let hasFAQ = false;
                let config: any = {};
                if (healthData.content) {
                    config = JSON.parse(healthData.content);
                    mModule = config.module;
                    let ruleList = config.rule.list;
                    let _maxScore = config.rule.type === 'range' ? ruleList[ruleList.length - 1]?.score[1] : ruleList[ruleList.length - 1]?.rate[1];
                    mModule = mModule.map((v: any) => {
                        if (v.type == 'healthTrend') {
                            hasHealthTreand = true;
                        }
                        if (v.type == 'FAQ') {
                            hasFAQ = true;
                        }
                        if (v.type == 'multiFunctionEvaluationRecord') {
                            const _map = {};
                            sourceData.forEach((vv: any) => {
                                _map[vv.key] = vv.value;
                            });
                            const renderList = v.items.map((val: any) => {
                                let _value = _map[val.dataCode];
                                let _index = ruleList.findIndex((val: any) => {
                                    if (_value >= val.rate[0] && _value <= val.rate[1]) {
                                        return true;
                                    }
                                })
                                let _item = ruleList[_index] || {};
                                console.log('ruleList', ruleList);
                                return {
                                    ...val,
                                    value: _value,
                                    fillColor: _item.color || '',
                                }
                            });
                            return {
                                ...v,
                                score: _score,
                                rule: config.rule,
                                ruleType: config.rule.type,
                                list: ruleList,
                                maxScore:_maxScore,
                                sourceData: sourceData,
                                renderList: renderList
                            }
                        } else {
                            return {
                                ...v,
                                score: _score,
                                rule: config.rule,
                                ruleType: config.rule.type,
                                list: ruleList,
                                maxScore:_maxScore
                            }
                        }
                    });
                    setScore(_score);
                    setFloorModules(mModule);
                    setQuestionnaireCode(_data.questionnaireCode);
                    setRuleType(config.rule.type);
                }
                if (hasHealthTreand) { // percentage
                    getChartData('', _data.questionnaireCode, mModule, config.rule.type);
                }
                if (hasFAQ) {
                    getFAQ(id);
                }
            }
        })
    }

    const getChartData = (year: any, code: any, mModules: any, mRuleType: any, mTabNameIndex?: any) => {
        let curYear = (new Date()).getFullYear();
        let _year = year || curYear;
        let _questionnaireCode = code || questionnaireCode;
        api.getQuestionnaireRecordStatistics({
            year: _year,
            questionnaireCode: _questionnaireCode
        }).then((res: any) => {
            if (res.code == 0) {
                let _result = res.data || [];
                let _date: any = [];
                let _data: any = [];
                let _tabNameArr: any = [];
                let _legend: any = {};
                let _solidSeries: any = [];
                let _dashedSeries: any = [];
                let _mutiData: any = [];
                _result.forEach((v: any) => {
                    _mutiData.push([]);
                });
                let mmModules = mModules;
                const _index = mmModules.findIndex((val: any) => (val.type === 'healthTrend'));
                const targetModule = mmModules[_index];
                mTabNameIndex = mTabNameIndex !== undefined ? mTabNameIndex : tabNameActiveIndex
                _tabNameArr = targetModule.items.map((v: any) => {
                    v.setting.forEach((vv: any) => {
                        if (vv.type == 'solid') {
                                const __item = {
                                    itemConfigSetteing: vv,
                                    name: v.tabName,
                                    symbol: 'circle',
                                    data: [],
                                    type: 'line',
                                    itemStyle: {
                                        normal: {
                                            // borderColor: '#80E066', // 拐点边框颜色
                                            // color: '#80E066', // 拐点颜色
                                            borderWidth: 0, // 拐点边框大小
                                            color: function(params: any) {
                                                // return triangleBgColor(params.data);
                                                return dynamicTriangleBgColor(params.data, mModules, mRuleType);
                                            },
                                        },
                                    },
                                    lineStyle: {
                                        color: vv.color, //折线的颜色
                                        // color: dynamicLineBgColor(data[10].score, mModules, mRuleType, 'NV'), //折线的颜色
                                    }
                                };
                            // });
                            _solidSeries.push(__item)
                        } else if (vv.type == 'dashed') {
                            _dashedSeries.push({
                                name: v.tabName,
                                symbol: 'circle',
                                data: [],
                                type: 'line',
                                itemStyle: {
                                    normal: {
                                        borderWidth: 0, 
                                    },
                                },
                                markLine: {
                                    symbol: 'none',
                                    label: {
                                        show: true,
                                        color: vv.color
                                    },
                                    data: [{
                                        yAxis: vv.Y,
                                        lineStyle: {
                                            color: vv.color
                                        }
                                    }]
                                },
                                lineStyle: {
                                    color: vv.color, //折线的颜色
                                },
                            });
                        }
                    });
                    return v.tabName;
                });
                const _selected = {};
                _tabNameArr.forEach((val: any, index: number) => { 
                    _selected[val] = (index === mTabNameIndex);
                });
                if (_tabNameArr.length > 0) {
                    _legend = {
                        icon: 'none',
                        // data: ["综合得分", "功能维度"],
                        data: _tabNameArr,
                        padding: [0, 0],
                        itemGap: -25,
                        textStyle: {
                        //文字样式
                            // color: "#0222BB",
                            color: "transparent",
                            fontSize: "12",
                        },
                        // inactiveColor:"#8B8B8B",
                        inactiveColor: "transparent",
                        right: "0",
                        top: "0",
                        selectedMode: "single",
                        selected: _selected
                    }
                    // _legend
                }
                _result.forEach((v: any, index: number) => {
                    if (v.createTime) {
                        let _time = v.createTime.slice(5, 10);
                        _time = _time.replace('-', '/');
                        _date.push(_time);
                    } 
                    if (v.data && mRuleType === 'range') {
                        const _maps = JSON.parse(v.data);
                        const _map = {};
                        _maps.forEach((v: any) => {
                            _map[v.key] = v.value;
                        })
                        let _solidLines = [];
                        if (mmModules[_index] && mmModules[_index].items && mmModules[_index].items[0] && mmModules[_index].items[0].setting) {
                            _solidLines = mmModules[_index].items[0].setting;
                        }
                        _solidLines = _solidLines.filter((v: any) => !!v.dataCode);
                        const _solidItem = _solidLines[0];
                        const _score = _solidItem.dataCode;
                        _data.push(_map[_score]);
                    } else if (v.data && mRuleType === 'percentage') {
                        const _maps = JSON.parse(v.data);
                        const _map = {};
                        _maps.forEach((v: any) => {
                            _map[v.key] = v.value;
                        })
                        _solidSeries = _solidSeries.map((v: any, i: number) => {
                                    return {
                                        ...v,
                                        data: [...v.data, _map[v.itemConfigSetteing.dataCode]],
                                    }
                        });
                    } else {
                        _data.push(v.score);
                    }
                });
                if (mRuleType === 'range') {
                    initData(_date, _data, _result, mModules, mRuleType, _dashedSeries);
                } else if (mRuleType === 'percentage') {
                    initMutiData(_date, _data, _result, mModules, mRuleType, _solidSeries, _dashedSeries,  _legend);
                }
            }
        })
    }

    const getFAQ = (recordId: string) => {
        api.getListQuestionnaire({ recordId : recordId}).then((res: any) => {
            if (res.code == 0) {
                setFAQList(res.data);
            }
        });
    }

    const initData = (date: any = [], data: any = [], originData: any = [], mModules: any = [], mRuleType: string = '', dashedSeries: any = []) => {
        let nowMonth: any = (new Date()).getMonth() + 1;
        let nowDate: any = (new Date()).getDate();
        nowMonth = nowMonth < 10 ? '0' + nowMonth : nowMonth;
        nowDate = nowDate < 10 ? '0' + nowDate : nowDate;
        let chartDom: any = document.getElementById('aeTestDetailChart');
        let myChart = echarts.init(chartDom);
        let option;
        let activeToolIndex = -1;
        const urlParams = utils.getUrlParams() || {};
        let _id = urlParams.id;
        // 测试数据 ↓
        originData.forEach((v: any, k: number) => {
            if (v.id == _id) {
                activeToolIndex = k;
            }
        })
        const sum = data.reduce((preV: any, curV: any) => (parseFloat(preV) + parseFloat(curV)), 0);
        const average = sum / data.length;
        const curVal = data[activeToolIndex];
        let isCurrentAbove = curVal >= average; // 一条数据时是=，此时朝下
        if (data.length == 1 && data[0] == 0) { // 一条数据时是为零时，此时朝上
            isCurrentAbove = false;
        }
        let _dashedSeries = dashedSeries;
        // let mmModules = mModules || floorModules;
        // const _index = mmModules.findIndex((val: any) => (val.type === 'healthTrend'));
        // let _dashLines = []; 
        // if (mmModules[_index] && mmModules[_index].items && mmModules[_index].items[0] && mmModules[_index].items[0].setting) {
        //     _dashLines = mmModules[_index].items[0].setting;
        // }
        // let _dashDataLines = _dashLines.map((val: any) => {
        //     const _baseLineData = data.map((vv: any, index: number) => val.Y);
        //     return {
        //         ...val,
        //         symbol: 'line',
        //         data: _baseLineData,
        //         type: 'line',
        //         itemStyle: {
        //             normal: {
        //                 color: 'transparent',
        //                 lineStyle: {
        //                     color: val.color,
        //                     width: 1,
        //                     type: val.type  //'dotted'虚线 'solid'实线
        //                 }
        //             },
        //         }
        //     }
        // })
        option = {
            grid: {
                x: 30,
                y: 15,
                x2: 30,
                y2: 30
            },
            xAxis: {
                type: 'category',
                data: date,
                axisLabel: {  
                    // interval: 0,
                },
                axisTick: {
                    show: false
                },
                axisLine: {
                    lineStyle: {
                    color: '#ACACAC', // y轴的颜色
                    width: 0.5, //y轴线的宽度
                    },
                    show:true
                }
            },
            yAxis: {
                type: 'value',
                axisLine: {
                    lineStyle: {
                    color: '#ACACAC', // y轴的颜色
                    width: 0.5, //y轴线的宽度
                    },
                    show:true
                }
            },
            series: [
                {
                    symbol: 'circle',
                    data: data,
                    type: 'line',
                    itemStyle: {
                        normal: {
                            // borderColor: '#80E066', // 拐点边框颜色
                            // color: '#80E066', // 拐点颜色
                            borderWidth: 0, // 拐点边框大小
                            color: function(params: any) {
                                // return triangleBgColor(params.data);
                                return dynamicTriangleBgColor(params.data, mModules, mRuleType);
                            },
                        },
                    },
                    lineStyle: {
                        color: '#5F2CB7', //折线的颜色
                        // color: dynamicLineBgColor(data[10].score, mModules, mRuleType, 'NV'), //折线的颜色
                    },
                },
                // ..._dashDataLines,
                ..._dashedSeries
            ],
            tooltip: {
                trigger: 'axis',
                className: 'test_detail_tooltip_wrap',
                triggerOn: 'none', // 禁止再次点击
                axisPointer: {
                    type: 'none'
                },
                position: function (point: any, params: any, dom: any, rect: any, size: any) {
                    return point;  //返回x、y（横向、纵向）两个点的位置
                },
                formatter: function(params: any){
                    return `<div class="test_detail_tooltip_item ${isCurrentAbove ? 'test_detail_below_of_average' : 'test_detail_above_of_average'}">
                                <div>本次</div>
                            </div>`;
                }
            },
        };
        option && myChart.setOption(option);
        myChart.dispatchAction({
            type: 'showTip',
            seriesIndex: 0,
            dataIndex: activeToolIndex
        })
    }

    const initMutiData = (date: any = [], data: any = [], originData: any = [], mModules: any = [], mRuleType: string = '', dataSeries: any = [], dashedSeries: any = [], mLegend: any = {}) => {
        let nowMonth: any = (new Date()).getMonth() + 1;
        let nowDate: any = (new Date()).getDate();
        nowMonth = nowMonth < 10 ? '0' + nowMonth : nowMonth;
        nowDate = nowDate < 10 ? '0' + nowDate : nowDate;
        let chartDom: any = document.getElementById('aeTestDetailChart');
        let myChart = echarts.init(chartDom);
        let option;
        let activeToolIndex = 0;
        let activeSeriesIndex = 0;
        const urlParams = utils.getUrlParams() || {};
        let _id = urlParams.id;
        const _selectedMap: any = mLegend?.selected || {};
        originData.forEach((v: any, k: number) => {
            if (v.id == _id) {
                activeToolIndex = k;
            }
        })
        activeSeriesIndex = dataSeries.findIndex((val: any) => _selectedMap[val.name]);
        const activeData = dataSeries.filter((val: any) => _selectedMap[val.name]).map((v: any) => v.data[activeToolIndex]);
        const sum = activeData.reduce((preV: any, curV: any) => (parseFloat(preV) + parseFloat(curV)), 0);
        const average = sum / activeData.length;
        const curVal = dataSeries[activeSeriesIndex].data[activeToolIndex];
        const isCurrentAbove = curVal > average;
        const _dashedSeries = dashedSeries || [];
        // 切换tab选中对应tab的第一条
        option = {
            legend: mLegend,
            grid: {
                x: 30,
                y: 15,
                x2: 30,
                y2: 30
            },
            xAxis: {
                type: 'category',
                data: date,
                axisLabel: {  
                    // interval: 0,
                },
                axisTick: {
                    show: false
                },
                axisLine: {
                    lineStyle: {
                    color: '#ACACAC', // y轴的颜色
                    width: 0.5, //y轴线的宽度
                    },
                    show:true
                }
            },
            yAxis: {
                type: 'value',
                axisLine: {
                    lineStyle: {
                    color: '#ACACAC', // y轴的颜色
                    width: 0.5, //y轴线的宽度
                    },
                    show:true
                }
            },
            series: [
                ...dataSeries,
                ..._dashedSeries,
            ],
            tooltip: {
                trigger: 'axis',
                className: 'test_detail_tooltip_wrap',
                triggerOn: 'none', // 禁止再次点击
                axisPointer: {
                    type: 'none'
                },
                position: function (point: any, params: any, dom: any, rect: any, size: any) {
                    return point;  //返回x、y（横向、纵向）两个点的位置
                },
                formatter: function(params: any){
                    return `<div class="test_detail_tooltip_item ${isCurrentAbove ? 'test_detail_below_of_average' : 'test_detail_above_of_average'}">
                                <div>本次</div>
                            </div>`;
                }
            },
        };
        option && myChart.setOption(option);
        myChart.dispatchAction({
            type: 'showTip',
            seriesIndex: activeSeriesIndex,
            dataIndex: activeToolIndex
        })
    }

    const dynamicTriangleBgColor = (mScore: any, mFloorModules: any, mRuleType: any) => {
        let score = mScore;
        let color_arr = []
        const index = mFloorModules.findIndex((val: any) => val.type === 'healthTrend')
        const list = mFloorModules[index].list;
        if (mRuleType == 'range') {
            color_arr = (list || []).filter((val: any) => (val.score[0] <= score && val.score[1] >= score))
        } else if (mRuleType == 'percentage') {
            color_arr = (list || []).filter((val: any) => (val.rate[0] <= score && val.rate[1] >= score))
        }
        const color = color_arr[0]?.color || '';
        return color;
    }

    const dynamicLineBgColor = (mScore: any, mFloorModules: any, mRuleType: string, dataCode: string) => {
        if (mRuleType == 'range') {
            return '#5F2CB7';
        } else if (mRuleType == 'percentage') {
            const index = mFloorModules.findIndex((val: any) => {
                if (val.type === 'multiFunctionEvaluationRecord') {
                    return true;
                }
            })
            const items = mFloorModules[index].items;
            const dataIndex = items.findIndex((val: any) => {
                if (val.dataCode === dataCode) {
                    return true;
                }
            })
            const result = items[index] || {};
            return result.color;
        }

    }

    
    // 展开、收起
    const toExpand = () => {
        setIsTextExpand(!isTextExpand);
    }
    // 常见问答
    const toAskDetail = (val: any) => {
        props.history.push(`/alk/commonAsk/detail?id=${val.id}`);
    }

    // 显示picker
    const showPicker = () => {
        setVisible(true);
    }

    //切换年份
    const changeYear = (year: any) => {
        let _year = year.toString()
        getChartData(_year, questionnaireCode, floorModules, ruleType);
    }

    const toTabNameActiveIndex = (key: number) => {
        setTabNameActiveIndex(key);
        // 更新数据
        setTimeout(() => {
            getChartData('', questionnaireCode, floorModules, ruleType, key);
        }, 0);
    }

    const renderEvaluationRecord= (floor: any =  {}) => {
        if (floor.type !== 'evaluationRecord') {
            return null;
        }
        const color_arr = (floor.list || []).filter((val: any) => (val.score[0] <= floor.score && val.score[1] >= floor.score))
        const color = color_arr[0]?.color || '';
        const desc = color_arr[0]?.desc || '';
        return (
            <div className={styles.top_intro}>
                <div className={styles.top_intro_head}>
                    <div className={styles.top_place}></div>
                    <img className={styles.chart_record} src={chart_record} alt="" />
                    <div className={styles.top_intro_head_text}>您的本次评测记录({recordTime})</div>
                    {/* <img className={styles.chart_arrow} src={chart_arrow_down_white} alt="" /> */}
                    <div className={styles.top_place}></div>
                </div>
                <div className={styles.top_intro_middle}>
                    <div className={styles.top_intro_top}>
                        {floor.title}
                    </div>
                    <div className={`${styles.top_intro_center}`}
                        style={{ color: color }}
                    >
                        {score}
                    </div>
                    <div className={`${styles.top_intro_bottom}`}>
                        <div style={{ color: color, border: `1px solid ${color}` }}>{desc}</div>
                    </div>
                </div>
            </div>
        )
    }

    // 渲染评分说明楼层
    const renderScoringInstructions = (floor: any =  {}) => {
        if (floor.type !== 'scoringInstructions') {
            return null;
        }
        return (
        <div className={styles.middle_intro}>
            <div className={styles.middle_intro_top} >
                <img className={styles.middle_intro_top_img} src={chart_rate_detail} alt="" />
                <span>评分说明</span>
            </div>
            <div className={styles.middle_intro_middle}>
                引用量表：{recordData.cname}{recordData.ename}
            </div>
            <div className={styles.middle_intro_bottom}>
                {recordData.remark}
            </div>
            <div className={`${styles.middle_intro_bottom_introl}`}>
                {
                    floor.list && floor.list.map((val: any, key: number) => (
                        <div className={styles.i_item_nav} key={key}>
                            <div className={styles.borderRect} style={{ backgroundColor: val.color }}></div>
                            <div className={styles.item_txt}>{val.desc}</div>
                        </div>
                    ))
                }
            </div>
        </div>
        )
    }

    // 渲染评分说明楼层
    const renderScoringRules = (floor: any = {}) => {
        if (floor.type !== 'scoringRules') {
            return null;
        }
        const triangle_color_arr = floor.list.filter((val: any) => (val.score[0] <= floor.score && val.score[1] >= floor.score))
        const triangle_color = triangle_color_arr[0]?.color?.split('#')[1];
        return (
        <div className={styles.bar_wrap}>
            <div className={styles.bar}>
                <div
                    style={{ 
                        left: score * 100 / floor.maxScore + '%',
                        backgroundImage: `url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='22' height='16' viewBox='0 0 22 16'%3E%3Cdefs%3E%3Cstyle%3E.a%7Bfill:%23${triangle_color};%7D%3C/style%3E%3C/defs%3E%3Cpath class='a' d='M11,0,22,16H0Z' transform='translate(22 16) rotate(180)'/%3E%3C/svg%3E")`,
                    }} className={styles.triangle_item}
                >
                </div>
                {
                    floor.list && floor.list.map((val: any, key: number) => (
                    <div className={`${styles.i_item}`} style={{ width: `${(val.score[1] - val.score[0] + (key == 0 ? 0 : (val.score[0] - floor.list[key - 1].score[1]))) * 100 / floor.maxScore }%`}} key={key}>
                        <div className={`${styles.item} ${key == 0 ? styles.first : ''} ${key == floor.list.length - 1 ? styles.last : ''}`} style={{ backgroundColor: val.color }}></div>
                        <div style={{ textAlign: 'center' }}>
                            <div>{val.score[0]}</div>
                            <div>|</div>
                            <div>{val.score[1]}</div>
                        </div>
                    </div>
                    ))
                }
            </div>
        </div>
        )
    }

    // 渲染图表楼层
    const renderHealthTrend = (floor: any = {}) => {
        if (floor.type !== 'healthTrend') {
            return null;
        }
        // const active_color_arr = floor.list.filter((val: any) => (val.score[0] <= floor.score && val.score[1] >= floor.score))
        let navList = [];
        if (floor.items && floor.items[tabNameActiveIndex] && floor.items[tabNameActiveIndex].setting) {
            // navList = floor.items[tabNameActiveIndex].setting;
            navList = floor.items[tabNameActiveIndex].setting.filter((val: any) => val.type === 'solid' || val.display); // dash 时 display 为 true 时展示 
        }
        return (<>
            {/* <div className={styles.gap}></div> */}
            <div className={styles.bottom_intro}>
                <div className={styles.bottom_intro_head}>
                    <img src={chart_health_trend} alt="" />
                    <div className={styles.trend}>健康趋势</div>
                    {
                        floor.items && floor.items.length > 1 &&
                        <div className={styles.tab_name_wrap}>
                        {
                            floor.items && floor.items.map((val: any, key: number) => (
                                <div onClick={() => { toTabNameActiveIndex(key) }} key={key} className={ `${styles.tab_name} ${tabNameActiveIndex == key ? styles.tab_name_active : ''}`}>{val.tabName}</div>
                            ))
                        }
                    </div>
                    }
                </div>
                <div className={styles.bottom_intro_middle}>
                    <span className={styles.l}>一年健康趋势</span>
                    <span className={styles.r} onClick={showPicker}>
                        <span>{currenrYear}年</span>
                        <img src={arrow_down_gray} alt="" />
                    </span>
                </div>
                <div className={`${styles.bottom_intro_middle_bt} ${styles.middle_intro_bottom_introl} ${styles.tx_c}`}>
                    {
                        navList.map((val: any, key: number) => {
                            const item_color = val.color?.split('#')[1];
                            return (
                                <div className={`${styles.i_item}`} key={key}>
                                    {
                                        val.type == 'solid' ?
                                        <img src={`data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='38' height='14' viewBox='0 0 38 14'%3E%3Cg id='组_4430' data-name='组 4430' transform='translate(-413 -1059)'%3E%3Ccircle id='椭圆_2086' data-name='椭圆 2086' cx='7' cy='7' r='7' transform='translate(425 1059)' fill='%23${item_color}'/%3E%3Cline id='直线_1355' data-name='直线 1355' x2='38' transform='translate(413 1066.5)' fill='none' stroke='%23${item_color}' stroke-width='2'/%3E%3C/g%3E%3C/svg%3E%0A`} alt="" />
                                        :
                                        <img src={`data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='38' height='14' viewBox='0 0 38 14'%3E%3Cdefs%3E%3Cstyle%3E.a%7Bfill:%23${item_color};%7D.b%7Bfill:none;stroke:%23${item_color};stroke-width:2px;stroke-dasharray:4;%7D%3C/style%3E%3C/defs%3E%3Cg transform='translate(-125 -1059)'%3E%3Ccircle class='a' cx='7' cy='7' r='7' transform='translate(137 1059)'/%3E%3Cline class='b' x2='38' transform='translate(125 1066.5)'/%3E%3C/g%3E%3C/svg%3E`} alt="" />
                                    }
                                    {/* dashed */}
                                    <div className={styles.item_txt}>{val.name}</div>
                                </div>
                            )
                        })
                    }
                </div>
                <div id="aeTestDetailChart" style={{ width: "100%", height: "200%" }}>
                </div>
            </div>
        </>)
    }

    const renderColor = (val: any, floor: any) => {
        let _color = '#447AE6';
        let percent = (val.value / val.total) * 100;
        let percentColorList = floor?.rule?.list || [];
        percentColorList.some((val: any) => {
            if (val.rate[0] <= percent && percent <= val.rate[1]) {
                _color = val.color;
                return true;
            }
        })
        return _color;
    }

    const renderMutiEvaluationRecord = (floor: any) => {
        return (
            <div>
                <div className={styles.t_header}>
                    <div className={styles.t_title}>
                        <img src={icon_health_title} alt="" />
                        <span>您的本次评测记录({recordTime})</span>
                    </div>
                    <div className={styles.t_sub_title}>引用量表：{recordData.cname}{recordData.ename}</div>
                </div>
                <div className={styles.t_progress}>
                    {
                        floor.renderList && floor.renderList.map((val: any, key: number) => (
                            <div className={styles.t_progress_item} key={key }>
                                <div>
                                    <div className={styles.t_circle} style={{ backgroundColor: val.color}}></div>
                                    <div className={styles.t_desc}>{val.name}</div>
                                </div>
                                <div>
                                    <ProgressCircle percent={(val.value / val.total) * 100} style={{ '--track-width': '6px', '--fill-color': renderColor(val, floor) }}  >
                                        <span style={{ color: renderColor(val, floor) }}>{parseInt(val.value)}</span>
                                        {/* <span style={{ color: val.fillColor }}>{parseInt(val.value)}</span> */}
                                    </ProgressCircle>
                                </div>
                        </div>
                        ))
                    }
                </div>
            </div>
        )
    }

    const renderEvaluationDimensionDescription = (floor: any) => {
        return (
            <div className={styles.m_intro_wrap}>
                <div className={styles.m_intro}>
                    <div className={styles.m_intro_top}>
                        <div className={styles.title}>评测维度说明</div>
                        <div onClick={toExpand}>{isTextExpand ? '收起' : '展开'}</div>
                        <div><img className={`${isTextExpand ? styles.up : styles.down}`} src={to_expand_arrow} alt="" /></div>
                    </div>
                    <div className={`${styles.m_intro_content} ${isTextExpand ? '' : styles.content_line_three}`}>
                        {recordData.remark}
                    </div>
                </div>
            </div>
        )
    }

    const renderPercentageScoringRules = (floor: any) => {
        return (
            <div className={styles.t_progress_desc}>
                <div className={styles.t_l}>情况最轻微</div>
                <div className={styles.t_m}>
                    <div></div>
                </div>
                <div className={styles.t_r}>情况最严重</div>
            </div>
        )
    }

    const renderFAQ = (floor: any) => {
        return (
            <div className={styles.b_QA_wrap}>
                <div className={styles.b_QA}>
                    <div className={styles.title}>
                        <img src={commonQA} alt="" />
                        <span>常见问答</span>
                    </div>
                    {
                        FAQList && FAQList.map((val: any, key: number) => (
                            <div className={styles.item} key={key} onClick={() => { toAskDetail(val); }}>
                                <img className={styles.qa} src={QA} alt="" />
                                <div className={styles.text}>{val.title}</div>
                                <img className={styles.r_arrow_blue} src={r_arrow_blue} alt="" />
                            </div>
                        ))
                    }
                </div>
            </div>
        )
    }

    return (
        <div className={styles.test_detail_container}>
            {
                floorModules && floorModules.map((val: any, key: number) => (
                    val.type === 'evaluationRecord' ? renderEvaluationRecord(val)
                    : val.type === 'scoringInstructions' ? renderScoringInstructions(val)
                    : val.type === 'scoringRules' && val.ruleType === 'range' ? renderScoringRules(val)
                    : (val.type === 'healthTrend') ? renderHealthTrend(val)
                    : (val.type === 'multiFunctionEvaluationRecord' && val.ruleType === 'percentage') ? renderMutiEvaluationRecord(val)
                    : (val.type === 'evaluationDimensionDescription') ? renderEvaluationDimensionDescription(val)
                    : (val.type === 'scoringRules' && val.ruleType === 'percentage') ? renderPercentageScoringRules(val)
                    : (val.type === 'FAQ') ? renderFAQ(val)
                    : null
                ))
            }
            <Picker
                columns={yearColumns}
                visible={visible}
                onClose={() => { setVisible(false) }}
                value={currenrYear}
                onConfirm={v => { setCurrenrYear(v); changeYear(v) }}
            />
        </div>
    )
}

export default withRouter(AeTestDetail);